import Header from "./components/Header";
import HomePage from "./components/HomePage";
import { Route, Routes } from "react-router-dom";
import InsertCard from "./components/admin/InsertCard";
import FoodPage from "./components/FoodPage";
import BlogPage from "./components/BlogPage";
import InsertBlog from "./components/admin/InsertBlog";
import AboutUS from "./components/AboutUS";
import ClothsPage from "./components/ClothsPage";
import InsertCategoryCard from "./components/admin/InsertCategoryCard";
import Footer from "./components/Footer";
import BlogList from "./components/admin/BlogList";
import UpdateBlog from "./components/admin/UpdateBlog";
import BabyFood from "./components/BabyFood";
import ReactGA from "react-ga";
import Users from "./components/Users";
import Users1 from "./components/Users1";
import Users7Month from "./components/Users7Month";
import Users8Month from "./components/Users8Month";
import BabyFood7Month from "./components/BabyFood7Month";
import BabyFood8Month from "./components/BabyFood8Month";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import ContactUS from "./components/ContactUS";
import PageComponent from "./components/PageComponent";
import UsersSpices from "./components/UsersSpices";
import BabyFoodSpices from "./components/BabyFoodSpices";
import FoodReciepesVideo from "./components/FoodReciepesVideo";
import Blogs from "./components/Blogs";
import BabyFood6MonthHindi from "./components/BabyFood6MonthHindi";
import FoodCharts from "./components/FoodCharts";
import FoodChartsHindi from "./components/FoodChartsHindi";
import AdsComponent from "./components/AdsComponent";
import Toys from "./components/Toys";
import NewMomChecklist from "./components/NewMomChecklist";
import FoodPlateChecklist from "./components/FoodPlateChecklist";
import ProofingChecklist from "./components/ProofingChecklist";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BabyFood7MonthHindi from "./components/BabyFood7MonthHindi";
import BabyFood9Month from "./components/BabyFood9Month";
import BabyFood10Month from "./components/BabyFood10Month";
import Subscribers from "./components/admin/Subscribers";
import RecipeCard from "./components/Blogs/RecipePage";
import RecipePage from "./components/Blogs/RecipePage";
import PageNotFound from "./components/PageNotFound";
import BabyFood8MonthHindi from "./components/BabyFood8MonthHindi";
import PaymentPage from "./components/PaymentPage";
import PaymentVerifyPage from "./components/PaymentVerifyPage";
import BabyFood11Month from "./components/BabyFood11Month";
import SendEmail from "./components/admin/SendEmail";
import InstaVideos from "./components/InstaVideos";
import AddFoodVideo from "./components/admin/AddFoodVideo";
import { Provider } from "react-redux";
import store from "./utils/redux/store";
import Login from "./components/admin/Login";
import Dashboard from "./components/admin/Dashboard";
import RecipePagePreview from "./components/admin/RecipePagePreview";
import BabyFood9MonthHindi from "./components/BabyFood9MonthHindi";
import GeneratePdf from "./components/GeneratePdf";
import InsertInfoBlog from "./components/admin/InsertInfoBlog";
import InfoPagePreview from "./components/admin/InfoPagePreview";
import InfoBlogs from "./components/InfoBlogs";
import InfoPage from "./components/Blogs/InfoPage";
import AddFirstCryCode from "./components/admin/AddFirstCryCode";
import AddSocialCount from "./components/admin/AddSocialCount";
import Invoice from "./components/admin/Invoice";
import InsertGoogleQuestions from "./components/admin/InsertGoogleQuestions";
import GoogleQuestionsPage from "./components/admin/GoogleQuestionsPage";
import IronRichRecipes from "./components/IronRichRecipes";
import IronRichRecipesVideos from "./components/IronRichRecipesVideos";
import AddInvoice from "./components/admin/AddInvoice";
import EditInvoice from "./components/admin/EditInvoice";
import ToysList from "./components/ToysList";
import YouTubeVideo from "./components/YouTubeVideo";
import DubaiItinerary from "./components/DubaiItinerary";

const TRACKING_ID = "G-VLLGEZ81FC";
ReactGA.initialize(TRACKING_ID);

export default function App() {
  return (
    <div className="w-full h-screen">
      <Provider store={store}>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/insertcard" element={<InsertCard />} />
          <Route path="/insertcategorycard" element={<InsertCategoryCard />} />
          <Route path="/insertblog" element={<InsertBlog />} />
          <Route path="/insertinfoblog" element={<InsertInfoBlog />} />
          <Route
            path="/recipeblogpreview/:recipe"
            element={<RecipePagePreview />}
          />
          <Route
            path="/infoblogpreview/:recipe"
            element={<InfoPagePreview />}
          />
          <Route path="/food" element={<FoodPage />} />
          <Route path="/blogs/:title" element={<BlogPage />} />
          <Route path="/aboutus" element={<AboutUS />} />
          <Route path="/contactus" element={<ContactUS />} />
          <Route path="/cloths" element={<ClothsPage />} />
          <Route path="/toys1" element={<Toys />} />
          <Route path="/admin/sendemail" element={<SendEmail />} />
          <Route path="/admin/addfoodvideo" element={<AddFoodVideo />} />
          <Route path="/admin/blogs" element={<BlogList />} />
          <Route path="/admin/blogs/:category" element={<UpdateBlog />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/addfirstcrycode" element={<AddFirstCryCode />} />
          <Route
            path="/admin/addsocialmediacount"
            element={<AddSocialCount />}
          />
          <Route
            path="/baby-food-recipes-video"
            element={<FoodReciepesVideo />}
          />
          <Route
            path="/recipe-videos/baby-food-recipe-videos"
            element={<InstaVideos />}
          />
          <Route
            path="/recipe-videos/iron-rich-recipe-videos"
            element={<IronRichRecipesVideos />}
          />
          <Route path="/babyfoodcharts" element={<FoodCharts />} />
          <Route path="/babyfoodchartshindi" element={<FoodChartsHindi />} />
          <Route
            path="/babyfoodcharts/6-month-baby-food-chart"
            element={<BabyFood />}
          />
          <Route
            path="/babyfoodcharts/6-month-baby-food-chart-hindi"
            element={<BabyFood6MonthHindi />}
          />
          <Route
            path="/babyfoodcharts/7-month-baby-food-chart-hindi"
            element={<BabyFood7MonthHindi />}
          />
          <Route
            path="/babyfoodcharts/8-month-baby-food-chart-hindi"
            element={<BabyFood8MonthHindi />}
          />
          <Route
            path="/babyfoodcharts/9-month-baby-food-chart-hindi"
            element={<BabyFood9MonthHindi />}
          />
          <Route
            path="/babyfoodcharts/iron-rich-food-recipes"
            element={<IronRichRecipes />}
          />
          <Route path="/test" element={<GeneratePdf />} />
          <Route
            path="/babyfoodcharts/7-month-baby-food-chart"
            element={<BabyFood7Month />}
          />
          <Route path="/babyfoodspices" element={<BabyFoodSpices />} />
          <Route
            path="/babyfoodcharts/8-month-baby-food-chart"
            element={<BabyFood8Month />}
          />
          <Route
            path="/babyfoodcharts/9-month-baby-food-chart"
            element={<BabyFood9Month />}
          />
          <Route
            path="/babyfoodcharts/10-month-baby-food-chart"
            element={<BabyFood10Month />}
          />
          <Route
            path="/babyfoodcharts/11-12-month-baby-food-chart"
            element={<BabyFood11Month />}
          />
          <Route path="/newmomchecklist" element={<NewMomChecklist />} />
          <Route path="/dubaiitinerary" element={<DubaiItinerary />} />
          <Route path="/foodplatecheklist" element={<FoodPlateChecklist />} />
          <Route path="/proofingheklist" element={<ProofingChecklist />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users1" element={<Users1 />} />
          <Route path="/users6" element={<UsersSpices />} />
          <Route path="/users7" element={<Users7Month />} />
          <Route path="/users8" element={<Users8Month />} />
          <Route path="/baby-food-recipes" element={<Blogs />} />
          <Route
            path="/parenting-blog/7-days-7-breakfast-recipes"
            element={<InfoBlogs />}
          />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termsofuse" element={<TermsOfUse />} />
          <Route path="/admin/subscribers" element={<Subscribers />} />
          <Route
            path="/baby-food-recipes/:month/:recipe"
            element={<RecipePage />}
          />
          <Route path="/parenting-blog/:title" element={<InfoPage />} />
          <Route path="/recipe" element={<RecipeCard />} />
          <Route path="/admin/invoice" element={<Invoice />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/paymentverify" element={<PaymentVerifyPage />} />
          <Route
            path="/admin/googlequestions"
            element={<InsertGoogleQuestions />}
          />
          <Route path="/admin/createinvoice" element={<AddInvoice />} />
          <Route path="/admin/editinvoice" element={<EditInvoice />} />
          <Route
            path="/admin/googlequestionspage"
            element={<GoogleQuestionsPage />}
          />
          <Route path="/toys/top_25_toys_links" element={<ToysList />} />
          <Route path="/toys/top-25-toys-links" element={<ToysList />} />
          <Route path="/toys" element={<ToysList />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/detailed-cookies-recipe" element={<YouTubeVideo />} />
        </Routes>
        <Footer />
        <>
          <PageComponent />
        </>
        <ToastContainer />
      </Provider>
    </div>
  );
}
